// services/agingReport.service.ts

import { AgingFilter } from "../types/aging.types";
import agingReportApi from "../api/agingReport.api";

const AgingReportService = {
  /**
   * 📊 Resumen superior
   * GET /api/receivables/aging/summary
   */
  getSummary: async () => {
    const response =
      await agingReportApi.fetchCustom(
        "/summary"
      );

    return response.data;
  },

  /**
   * 📄 Tabla paginada
   * POST /api/receivables/aging/table?page=0&size=10&sort=customerName,asc
   */
  getTable: async (
    filters: AgingFilter,
    page = 0,
    size = 10,
    sort = "customerName,asc"
  ) => {
    const response =
      await agingReportApi.addCustom(
        `/table?page=${page}&size=${size}&sort=${sort}`,
        filters
      );

    return response.data;
  },
};

export default AgingReportService;